import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import Link from "next/link";
import React from "react";
import customPageLeftShape from "@/assets/common/customPageLeftShape.svg";
import Image from "next/image";

type Props = {
  data: Simplify<Content.SupportAfterReportingSectionSliceDefaultPrimary>;
};

export default function SupportServiceCta({ data }: Props) {
  return (
    <Card className="shadow-none border-none bg-[#045B91] text-white relative rounded-xl">
      <CardHeader>
        <CardTitle>
          <div className="flex items-start md:items-center gap-4">
            <Button
              size="icon"
              className="rounded-full bg-[#EBF7FF] shrink-0 size-14"
            >
              <PrismicNextImage field={data.cta_icon} alt="" />
            </Button>

            <p className="text-2xl md:text-3xl font-semibold">
              {data.cta_heading}
            </p>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="md:px-24">
        <PrismicRichText
          field={data.cta_content}
          components={{
            paragraph: ({ children }) => (
              <p className="font-merriweather text-lg">{children}</p>
            ),
            hyperlink: ({ children, node }) => (
              <Link href={node.data.url || "#"} className=" underline">
                {children}
              </Link>
            ),
          }}
        />
      </CardContent>
      {/* overlays */}

      <Image
        src={customPageLeftShape.src}
        alt="left shape"
        width={710.44}
        height={659.7}
        className="absolute top-0 left-0 h-[350px] w-auto pointer-events-none"
      />
    </Card>
  );
}
